module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jules Bennett\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('I', [_vm._v("USA TODAY")]), _vm._v(" Bestselling Author Jules Bennett has penned more than 50 novels during her short career. She's married to her high school sweetheart, has two active girls, and is a former salon owner. Jules can be found on Twitter, Facebook (Fan Page), and her website julesbennett.com. She holds contests via these three outlets with each release and loves to hear from readers!")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19vimxF/tc-custom/9781488062964.jpg?1728851698484",
      "alt": "This image is the cover for the book Scandalous Engagement, Lockwood Lightning"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scandalous Engagement, Lockwood Lightning\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Delve into this scandalous friends-to-lovers romance, part of the Lockwood Lightning series from USA TODAY bestselling author Jules Bennett.  Their engagement may be fake but the chemistry is as real as it gets! Especially when one kiss with her best friend… changes everything.  Josie Coleman has the perfect plan to get rid of her bothersome ex-husband: pretend she’s about to marry again. But her fake engagement to her best friend, Reese Conrad, isn’t going as expected. His steamy, toe-curling kisses are anything but friendly…and their simple plan leads to very complicated feelings. Too bad that isn’t the only surprise Reese has in store…  From Harlequin Desire: A luxurious world of bold encounters and sizzling chemistry.  Lockwood Lightning: Book 1: An Unexpected Scandal Book 2: Scandalous Reunion Book 3: Scandalous Engagement")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0